import { QUESTION_SCENE_TYPE, QuestionDataSourceType, mapSceneType2DataSource } from '@patsnap/ls360_sdk_feature'
import { ILang } from '@patsnap/synapse_common_interface'
import { sharedCtx } from '@pharmsnap/shared/src/context'

export async function getLS360QuestionExamples(locale: ILang = 'EN'): Promise<Array<{ question: string; dataSource: QuestionDataSourceType }>> {
  const res = await sharedCtx.service.tag.getLS360HotTags({ scene_type: QUESTION_SCENE_TYPE })

  if (res.success) {
    const questionExamples = QUESTION_SCENE_TYPE.reduce((acc, scene) => {
      const currentSceneExamples = res.data?.hot_tag_map[scene]
        ?.filter((example) => example.content_language === locale)
        ?.sort((a, b) => (b.rnk || 0) - (a.rnk || 0))

      if (currentSceneExamples) {
        return acc.concat(
          currentSceneExamples.map((example) => ({
            question: example.display_name_en,
            dataSource: mapSceneType2DataSource(scene),
          }))
        )
      }
      return acc
    }, [] as Array<{ question: string; dataSource: QuestionDataSourceType }>)

    return questionExamples
  }
  return []
}
